import { Action } from 'redux';

export enum QuickSearchActionTypes {
	QUICK_SEARCH_RESULTS_GET = '@@search.data/QUICK_SEARCH_RESULTS_GET',
	QUICK_SEARCH_RESULTS_SUCCESS = '@@search.data/QUICK_SEARCH_RESULTS_SUCCESS',
	QUICK_SEARCH_RESULTS_FAILURE = '@@search.data/QUICK_SEARCH_RESULTS_FAILURE',
	QUICK_SEARCH_RESULTS_LOADING = '@@search.data/QUICK_SEARCH_RESULTS_LOADING',
}

export interface SearchTryGetResultsAction extends Action {
	readonly type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_GET;
	adviserUUID: string;
}

export interface SearchGetResultsSuccessAction extends Action {
	readonly type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_SUCCESS;
	response?: any;
}

export interface SearchGetResultsFailureAction extends Action {
	readonly type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_FAILURE;
	message?: string;
}

export interface SearchGetResultsLoadingAction extends Action {
	readonly type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_LOADING;
	message?: string;
}

export type SearchAction =
	| SearchTryGetResultsAction
	| SearchGetResultsSuccessAction
	| SearchGetResultsFailureAction
	| SearchGetResultsLoadingAction;

export function getQuickSearchResultsAction(
	adviserUUID: string
): SearchTryGetResultsAction {
	return {
		type: QuickSearchActionTypes.QUICK_SEARCH_RESULTS_GET,
		adviserUUID,
	};
}
